var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalVincularPessoa",
      attrs: { titulo: "Vincular pessoa", width: 500 },
      on: { closeModal: _vm.cancelar }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("app-label", {
                    attrs: {
                      label:
                        "Informe o CPF/CNPJ da pessoa que deseja inserir para acompanhar o processo.",
                      required: false
                    }
                  }),
                  _c(
                    "validation-observer",
                    { ref: "observer", attrs: { tag: "form" } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "cpfCnpj",
                          mode: "lazy"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "CPF/CNPJ:" }
                                }),
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: [
                                        "###.###.###-##",
                                        "##.###.###/####-##"
                                      ],
                                      expression:
                                        "['###.###.###-##', '##.###.###/####-##']"
                                    }
                                  ],
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "cpfCnpj",
                                    placeholder: "CPF/CNPJ"
                                  },
                                  model: {
                                    value: _vm.cpfCnpj,
                                    callback: function($$v) {
                                      _vm.cpfCnpj =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "cpfCnpj"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "validation-observer",
                    { ref: "uploadObserver", attrs: { tag: "form" } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("h4", [_vm._v("Anexar Procuração")]),
                                    _c("app-anexo", {
                                      attrs: {
                                        id:
                                          "upload-documentos-pessoas-vinculadas",
                                        exibirDownload: false,
                                        files: _vm.anexos,
                                        fileType: ["pdf"],
                                        errors: errors
                                      },
                                      on: {
                                        removeFile: _vm.removeFile,
                                        uploadFile: _vm.uploadFile
                                      },
                                      model: {
                                        value: _vm.anexos,
                                        callback: function($$v) {
                                          _vm.anexos = $$v
                                        },
                                        expression: "anexos"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c("span", { staticClass: "pessoas" }, [
                    _vm._v("Lista de pessoas que acompanham o processo")
                  ]),
                  _vm._l(this.naoExclui(), function(pessoa) {
                    return _c("div", { staticClass: "list" }, [
                      _c("span", [_vm._v(_vm._s(pessoa.nomeRazaoSocial))])
                    ])
                  }),
                  _vm._l(this.exclui(), function(pessoa) {
                    return _c(
                      "div",
                      { staticClass: "list" },
                      [
                        _c("span", [_vm._v(_vm._s(pessoa.nomeRazaoSocial))]),
                        _c(
                          "el-button",
                          {
                            staticClass: "botao",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.removerPessoa(pessoa)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons icon" }, [
                              _vm._v("close")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              { staticClass: "cancelarButton", on: { click: _vm.cancelar } },
              [
                _c("i", { staticClass: "fas fa-times" }),
                _c("span", [_vm._v("   Cancelar")])
              ]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.VincularPessoa } },
              [
                _c("i", { staticClass: "fas fa-check" }),
                _c("span", [_vm._v("  Confirmar")])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91803a64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91803a64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/VincularPessoa.vue
// module id = null
// module chunks = 